import React from 'react';
import { Button } from '@material-ui/core';

const MyButton = props => (
  <Button variant="contained" style={{
    marginTop: ".25rem ",
    marginBottom: ".25rem",
  }} {...props}>{props.children}</Button>
);

export default MyButton;


// WEBPACK FOOTER //
// ./src/pages/MyButton.js